import styled from '@emotion/styled'
import { css } from '@emotion/react'

import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'

type SubmitBtnProps = {
	isValid: boolean
}

const SubmitBtn = () => {
	const { isValid } = useMyProductFormContext()

	return (
		<div>
			<Button type="submit" isValid={isValid}>
				등록하기
			</Button>
		</div>
	)
}

const Button = styled.button<SubmitBtnProps>`
	width: 27rem;
	border: none;
	background: #ffcf19;
	opacity: 0.4;
	padding: 2rem 0;
	font-size: 1.6rem;
	font-weight: 700;

	${({ isValid }) =>
		isValid &&
		css`
			opacity: 1;
		`}
`

export default SubmitBtn
